import React from 'react';
import ComparisonSection from './zoneDisplayComponents/ComparisonSection';
import ComparisonTable from './zoneDisplayComponents/ComparisonTable';

const ZoneDisplay2 = ({
  zones,
  itemKey,
  pdfRef,
  doc2Visibility,
  toggleDoc2Visibility,
  handleSectionExport,
  markAllCheckboxes,
  markForExport,
  theadStyle,
  tbodyStyle,
  trStyle,
  trStyleFlexStart,
  thStyle,
  tdPropStyle,
  tdValueStyle,
  verticalLabel,
  containsPropVal,
  validateRCV,
  validateACV,
  validateTotal,
  renderProperNote,
  renderAddNote,
  handleCheckboxChange,
  percentValue,
  dynamicPercentColorChange,
  maxLength,
  data,
  comparisonID,
  returnDoc2Zones,
  lastRow,
  setDoc1Name,
  setDoc2Name,
  doc1Name,
  doc2Name,
  Yield,
  Close,
  GO
}) => {
  return Object.entries(zones).slice(2, 3).map(([lineItems, lineItemsObject]) => {
    const greenTables = [];
    const yellowTables = [];
    const zeroTables = [];

    // Process all line items and categorize them
    Object.entries(lineItemsObject)
      .filter(object => object[1]["Percentage"] >= percentValue)
      .sort((a, b) => a[1]["Percentage"] - b[1]["Percentage"])
      .forEach(([lineItemZero, lineItemZeroObject], index) => {
        const percentage = Number(lineItemZeroObject["Percentage"]);
        const tableId = `${zones["Zone 1"]} vs. ${zones["Zone 2"]} ${lineItemZero}`;
        const totalEntry = Object.entries(lineItemZeroObject).find(([key]) => key.toLowerCase() === 'total');
        const acvEntry = Object.entries(lineItemZeroObject).find(([key]) => key.toLowerCase() === 'acv');
        const rcvEntry = Object.entries(lineItemZeroObject).find(([key]) => key.toLowerCase() === 'rcv');
        
        const tableContent = (
          <ComparisonTable
            key={lineItemZero}
            tableId={tableId}
            lineItemZero={lineItemZero}
            lineItemZeroObject={lineItemZeroObject}
            zones={zones}
            index={index}
            totalLength={Object.entries(lineItemsObject).length}
            doc2Visibility={doc2Visibility}
            toggleDoc2Visibility={toggleDoc2Visibility}
            markForExport={markForExport}
            theadStyle={theadStyle}
            tbodyStyle={tbodyStyle}
            trStyle={trStyle}
            trStyleFlexStart={trStyleFlexStart}
            thStyle={thStyle}
            tdPropStyle={tdPropStyle}
            tdValueStyle={tdValueStyle}
            verticalLabel={verticalLabel}
            containsPropVal={containsPropVal}
            validateRCV={validateRCV}
            validateACV={validateACV}
            validateTotal={validateTotal}
            renderProperNote={renderProperNote}
            renderAddNote={renderAddNote}
            handleCheckboxChange={handleCheckboxChange}
            maxLength={maxLength}
            data={data}
            comparisonID={comparisonID}
            returnDoc2Zones={returnDoc2Zones}
            lastRow={lastRow}
            setDoc1Name={setDoc1Name}
            setDoc2Name={setDoc2Name}
            doc1Name={doc1Name}
            doc2Name={doc2Name}
            tableStyle={dynamicPercentColorChange(percentage, totalEntry, acvEntry, rcvEntry)}
          />
        );

        // Categorize tables based on percentage
        if (percentage === 100 || (totalEntry && totalEntry[1] === 0 && percentage >= 60) || (acvEntry && acvEntry[1] === 0) || (rcvEntry && rcvEntry[1] === 0)) {
          zeroTables.push(tableContent);
        } else if (percentage >= 43) {
          greenTables.push(tableContent);
        } else {
          yellowTables.push(tableContent);
        }
      });

    return (
      <div ref={pdfRef} key={lineItems} id={lineItems}>
        {/* Yellow Section */}
        {yellowTables.length > 0 && (
          <ComparisonSection
            sectionType="yellow"
            itemKey={itemKey}
            zones={zones}
            doc2Visibility={doc2Visibility}
            toggleDoc2Visibility={toggleDoc2Visibility}
            handleSectionExport={handleSectionExport}
            markAllCheckboxes={markAllCheckboxes}
            icon={Yield}
            tables={yellowTables}
          />
        )}

        {/* Green Section */}
        {greenTables.length > 0 && (
          <ComparisonSection
            sectionType="green"
            itemKey={itemKey}
            zones={zones}
            doc2Visibility={doc2Visibility}
            toggleDoc2Visibility={toggleDoc2Visibility}
            handleSectionExport={handleSectionExport}
            markAllCheckboxes={markAllCheckboxes}
            icon={Close}
            tables={greenTables}
          />
        )}

        {/* Zero Section */}
        {zeroTables.length > 0 && (
          <ComparisonSection
            sectionType="zero"
            itemKey={itemKey}
            zones={zones}
            doc2Visibility={doc2Visibility}
            toggleDoc2Visibility={toggleDoc2Visibility}
            handleSectionExport={handleSectionExport}
            markAllCheckboxes={markAllCheckboxes}
            icon={GO}
            tables={zeroTables}
          />
        )}
      </div>
    );
  });
};

export default ZoneDisplay2;
